import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://p1-backend-snowy.vercel.app/api',
  headers: { 'Content-Type': 'application/json' },
});

export default api;
